import type { VoiceCatalogEntry } from "@rakazo/contracts";

export type ReadAloudModelOption = {
  value: string;
  provider: string;
  modelId: string;
  label: string;
};

function usd(value: number): string {
  return Number.isInteger(value) ? `$${value}` : `$${value.toFixed(2)}`;
}

/**
 * The read-aloud models a bot can pick: each catalog speech model on a provider the owner has
 * connected, labelled with its list price per million characters when known.
 */
export function readAloudModelOptions(
  catalog: readonly VoiceCatalogEntry[],
  connectedProviders: readonly string[],
): ReadAloudModelOption[] {
  return catalog
    .filter((entry) => connectedProviders.includes(entry.id))
    .flatMap((entry) =>
      (entry.speechModels ?? []).map((model) => ({
        value: readAloudModelValue(entry.id, model.id),
        provider: entry.id,
        modelId: model.id,
        label: `${entry.name}: ${model.name}${
          model.usdPerMillionChars === undefined ? "" : ` · ${usd(model.usdPerMillionChars)}`
        }`,
      })),
    );
}

/** One select value for a provider's model; empty is the account default. */
export function readAloudModelValue(provider: string | null, modelId: string | null): string {
  return provider && modelId ? `${provider}:${modelId}` : "";
}
